import { IPublicClientApplication } from "@azure/msal-browser";

export default class TestApiService {

    msalInstance: IPublicClientApplication;

    constructor(msalInstance: IPublicClientApplication) {
        this.msalInstance = msalInstance;
    }

    public async whoAmI(): Promise<string> {
        let baseUrl = process.env.REACT_APP_API_URL;
        let url = baseUrl + '/api/data/v9.2/WhoAmI';

        let token = await this.acquireAccessToken();

        let result = await fetch(url, {
            method: 'get',
            headers: new Headers({
                "Authorization": "Bearer " + token
            })
        });

        if (!result.ok) {
            throw Error(result.statusText);
        }

        return result.text();
    }

    acquireAccessToken = async () => {
        const activeAccount = this.msalInstance.getActiveAccount(); // This will only return a non-null value if you have logic somewhere else that calls the setActiveAccount API        
        const accounts = this.msalInstance.getAllAccounts();
        if (!activeAccount && accounts.length === 0) {
            /*
            * User is not signed in. Throw error or wait for user to login.
            * Do not attempt to log a user in outside of the context of MsalProvider
            */
        }

        const baseUrl = process.env.REACT_APP_API_URL;

        const request = {
            scopes: [baseUrl + "//.default"],
            account: activeAccount || accounts[0]
        };

        const authResult = await this.msalInstance.acquireTokenSilent(request);

        return authResult.accessToken;
    };
}